import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import IVButton from '@invideoio/uniformd/components/Button';
import ivclass from '../../../Modules/IVClass';
import { HEADER_ACTION_LINK_ANIMATE } from '../../../constants/header';
const HeaderActions = (props) => {
    const { onSignUp, onLogin, headerActionLinkAnimate, loginText = 'Login', signUpText = 'Sign up', } = props;
    let headerActionClass = '';
    switch (headerActionLinkAnimate) {
        case HEADER_ACTION_LINK_ANIMATE.SCROLL_UP:
            headerActionClass = 'iv-signup-animate-out iv-text-blue';
            break;
        case HEADER_ACTION_LINK_ANIMATE.SCROLL_DOWN:
            headerActionClass = 'iv-signup-animate-in iv-text-grey-0';
            break;
        default:
            headerActionClass = 'iv-text-blue dark:iv-text-light-blue';
    }
    return (_jsxs("div", { className: ivclass('xl:iv-pt-2 lg:iv-pt-2 md:iv-pt-5'), children: [_jsx("button", { className: ivclass('iv-inline-block iv-text-body-xl md:iv-text-body-m iv-text-black-50 dark:iv-text-grey-30 iv-font-semibold iv-cursor-pointer'), type: "button", onClick: () => onLogin(), children: loginText }), _jsx(IVButton, { className: ivclass('iv-inline-flex iv-justify-center iv-items-center iv-cursor-pointer', 'iv-rounded-3xl', 'iv-border-2 iv-border-blue dark:iv-border-blue', 'iv-ml-[33px] md:iv-ml-[28px]', 'iv-px-[13px]', 'iv-h-28', 'iv-text-body-xl md:iv-text-body-m', 'hover:iv-text-grey-0 dark:hover:iv-text-grey-0 hover:iv-bg-blue dark:hover:iv-bg-blue', 'iv-font-semibold', 'iv-leading-none', headerActionClass), type: "button", onClick: () => onSignUp(), children: signUpText })] }));
};
export default HeaderActions;
